import {CustomTextField} from "../../../../../../components/CustomTextField";
import {FILE_TYPE} from "../../../../../../Helpers/fileType";
import {CustomDatePicker} from "../../../../../../components/CustomDatePicker";
import CustomTimePicker from "../../../../../../components/CustomTimePicker";
import CustomDateTimePicker from "../../../../../../components/CustomDateTimePicker";
import React, {useState} from "react";
import {FIELD_TYPE} from "../../../Type/Model/Model";
import CustomPhotoPicker from "../../../../../../components/PhotoPicker/CustomPhotoPicker";
import {ACTION_MODEL} from "../../../../../../Helpers/ActionModel";
import {useParams} from "react-router-dom";
import { CommonDocumentationFormApp } from './CommonDocumentationFormApp';


/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 */

export const DocumentationFormApp = ({setPhotoPickerList}) => {
    const [showBadgeMessage, setBadgeMessage] = useState(true);
    const {id} = useParams();
    const { getBaseProps, fieldsFormCheckBox} = CommonDocumentationFormApp();

    const handleCloseBadge = () => {
        setBadgeMessage(false);
    }

    const fieldsForm = (field, data, handleChange, emptyFields, isValidData) => {
        const base = getBaseProps(field, emptyFields);
        const value = data[field.fieldId]?.value;
        const isValid = isValidData[field.fieldId];

        const fieldRenderers = {
            [FIELD_TYPE.TEXT.name]: () => (
                <CustomTextField
                    {...base}
                    length={FIELD_TYPE.TEXT.length}
                    trans={field.fieldName}
                    value={value || ''}
                    onChange={e => handleChange(field, e.target.value)}
                />
            ),
            [FIELD_TYPE.NUMERIC.name]: () => (
                <CustomTextField
                    {...base}
                    type="number"
                    length={FIELD_TYPE.NUMERIC.length}
                    trans={field.fieldName}
                    value={value || ''}
                    onChange={e => handleChange(field, e.target.value)}
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                    showCounter={true}
                    countDecimals={false}
                />
            ),
            [FIELD_TYPE.DATE.name]: () => (
                <CustomDatePicker
                    {...base}
                    trans={field.fieldName}
                    value={value || null}
                    onChange={date => handleChange(field, date)}
                    openTo="day"
                    isValid={isValid}
                />
            ),
            [FIELD_TYPE.TIME.name]: () => (
                <CustomTimePicker
                    {...base}
                    title={field.fieldName}
                    value={value || null}
                    handleChange={time => handleChange(field, time)}
                    actions={['accept', 'cancel']}
                    isValid={isValid}
                />
            ),
            [FIELD_TYPE.DATE_TIME.name]: () => (
                <CustomDateTimePicker
                    {...base}
                    trans={field.fieldName}
                    value={value || null}
                    onChange={dateTime => handleChange(field, dateTime)}
                    isValid={isValid}
                />
            ),
        };
        return fieldRenderers[field.fieldType]?.();
    };

    const fieldsFormDocument = (field, emptyFields) => {
        if (field.fieldType !== FIELD_TYPE.DOCUMENT.name) return null;

        return (
            <div className="mb-3">
                <p className={"fs-12px ibl-font-w-600 font-color-general-950 mb-16px"}>
                    {field?.fieldName}
                    {field?.required && <span className={"font-color-error-700"}> * </span>}
                </p>
                <CustomPhotoPicker
                    key={`${field.fieldId}-${JSON.stringify(field.value)}`}
                    id={`fu_${field.fieldId}`}
                    photoPicker={field?.value}
                    setPhotoPicker={(newValue) => {
                        setPhotoPickerList(prevList =>
                            prevList.map(item => {
                                if (item.fieldId === field.fieldId) {
                                    const updatedValue =
                                        typeof newValue === 'function' ? newValue(item.value) : { ...item.value, ...newValue };
                                    return {
                                        ...item,
                                        value: updatedValue,
                                    };
                                }
                                return item;
                            })
                        );
                    }}
                    disabled={false}
                    actionModel={ACTION_MODEL.CREATE}
                    accept={{ ...FILE_TYPE.IMAGE_FILES_VIDEOS, size: FIELD_TYPE.DOCUMENT.length }}
                    titleInput={field.fieldName}
                    required={field.required}
                    showPreview={false}
                    classWith={'w-100'}
                    emptyFields={field.required && emptyFields}
                />
            </div>
        );
    };

    return {
        fieldsForm,
        fieldsFormDocument ,
        fieldsFormCheckBox,
        setBadgeMessage,
        id,
        handleCloseBadge
    };
};
